<template>
  <div class="gray-bg">
    <div class="wrapper wrapper-content" style="height: 100vh; padding-top: 40vh">
      <div class="text-center">
        <div style="margin: auto auto;">
        <h1>Loading...</h1>
        <div class="fa-3x text-center">
          <i class="fas fa-spinner-third slow-spin loading-spinner"></i>
          <slot />
        </div>
        </div>
      </div>
    </div>
  </div>       
</template>

<style scoped>
.loading-spinner {
  color: #c0c0c0;
}
.slow-spin {
  -webkit-animation: fa-spin 3s infinite linear;
  animation: fa-spin 3s infinite linear;
}
</style>

<script>
export default {
  name: 'LoadingLayout',
  components: {},
  data() {
    return {
      title: ""
    };
  },
  mounted() {},
  methods: {}
};
</script>